import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { message } from "antd";
import NewLoad from "../../Load/Load";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

function ChangePassword({ setOpen }) {
  const [loading, setLoading] = useState(false);

  const [isOldPasswordVisible, setOldPasswordVisible] = useState(false);
  const [isNewPasswordVisible, setNewPasswordVisible] = useState(false);
  const [isConfirmNewPasswordVisible, setConfirmNewPasswordVisible] =
    useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Old password is required"),
      newPassword: Yup.string()
        .required("New password is required")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
        ),
      confirmPassword: Yup.string()
        .required("Confirm password is required")
        .oneOf(
          [Yup.ref("newPassword")],
          "New password and confirm password should be match"
        ),
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        setLoading(true);

        const response =''
        // await changePassword({ ...values });

        if (response?.data?.success) {
          message.success(response?.data?.message);
          resetForm();
          setOpen(false)
        }
      } catch (error) {
        if (
          error.message === "Network Error" ||
          error.message.includes("ERR_INTERNET_DISCONNECTED")
        ) {
          message.error("Network Error");
          return;
        }
        // Handle specific error cases
        if (error?.response?.status === 401) {
          //   window.alert(
          //     "Your account is logged in to another device, please login again !"
          //   );
          //   localStorage.removeItem("token");
          //   window.location.href = "/login";
          message?.error("Unauthorized !");
        }
        if (error?.response?.status === 500) {
          message.error("Server not responding");
          return;
        } else {
          message.error(error?.response?.data?.message);
        }
      } finally {
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white  rounded-2xl shadow-lg w-[700px] h-[500px] flex flex-col">
        <h3 className="text-xl font-bold mb-1 text-center bg-[#1d2532] py-2 text-white">
          Change Password
        </h3>
        <div className="flex-1 overflow-y-auto">
          <form onSubmit={""} className="p-8">
            <div className="w-full">
              <label className="block mb-1">Old Password </label>
              <div className="relative">
                <input
                  id="oldPassword"
                  type={isOldPasswordVisible ? "text" : "password"}
                  name="oldPassword"
                  className="border border-gray-900 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.oldPassword}
                  placeholder="Enter your old password"
                />
                <button
                  type="button"
                  onClick={() => setOldPasswordVisible(!isOldPasswordVisible)}
                  className="absolute inset-y-0 right-0 flex items-center "
                >
                  <FontAwesomeIcon
                    icon={isOldPasswordVisible ? faEye : faEyeSlash}
                    className="text-gray-500 mr-2"
                  />
                </button>
              </div>
              {formik.touched.oldPassword && formik.errors.oldPassword && (
                <p className="text-red-600">{formik.errors.oldPassword}</p>
              )}
            </div>

            <div className="w-full mt-4">
              <label className="block mb-1">New Password</label>
              <div className="relative">
              <input
                id="newPassword"
                type={isNewPasswordVisible ? "text" : "password"}
                name="newPassword"
                className="border border-gray-900 p-2 w-full"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.newPassword}
                placeholder="Enter your new password"
              />
              <button
                  type="button"
                  onClick={() => setNewPasswordVisible(!isNewPasswordVisible)}
                  className="absolute inset-y-0 right-0 flex items-center "
                >
                  <FontAwesomeIcon
                    icon={isNewPasswordVisible ? faEye : faEyeSlash}
                    className="text-gray-500 mr-2"
                  />
                </button>
                </div>
              {formik.touched.newPassword && formik.errors.newPassword && (
                <p className="text-red-600">{formik.errors.newPassword}</p>
              )}
            </div>

            <div className="w-full mt-4">
              <label className="block mb-1">Confirm Password</label>
               <div className="relative">
              <input
                type={isConfirmNewPasswordVisible ? "text" : "password"}
                name="confirmPassword"
                className="border border-gray-900 p-2 w-full"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirmPassword}
                placeholder="Confirm your new password"
              />
               <button
                  type="button"
                  onClick={() => setConfirmNewPasswordVisible(!isConfirmNewPasswordVisible)}
                  className="absolute inset-y-0 right-0 flex items-center "
                >
                  <FontAwesomeIcon
                    icon={isConfirmNewPasswordVisible ? faEye : faEyeSlash}
                    className="text-gray-500 mr-2"
                  />
                </button>
              </div>
              {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                                <p className='text-red-600'>{formik.errors.confirmPassword}</p>
                            )}
            </div>
          </form>
        </div>
        <div className="flex justify-end p-4 border-t gap-6">
          <button
            onClick={handleClose}
            className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
          >
            Close
          </button>
          <button
            onClick={formik.handleSubmit}
            className=" text-white py-2 px-4 rounded-md w-52 bg-[#1d2532] hover:bg-[#100f0fcf] transition duration-200 mr-2"
          >
            Change Password
          </button>
        </div>
      </div>
      {loading && <NewLoad />}
    </div>
  );
}

export default ChangePassword;
